import { render, staticRenderFns } from "./editPageNav.vue?vue&type=template&id=fe5cfdd0&scoped=true&"
import script from "./editPageNav.vue?vue&type=script&lang=js&"
export * from "./editPageNav.vue?vue&type=script&lang=js&"
import style0 from "./editPageNav.vue?vue&type=style&index=0&id=fe5cfdd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5cfdd0",
  null
  
)

export default component.exports